export default {
	buyItNowButton: 'Buy it now',
	CTASeperator: 'OR',
	increaseOfferButton: 'Increase offer',
	makeAnOfferButton: 'Make an offer',
};
